import { loadedMovieKeyVisual } from './key_visual_loaded_common'

loadedMovieKeyVisual(true)